import { Component } from '@angular/core';

@Component({
    selector: 'app-planting-site-placeholder',
    template: `<div class="col-12 no-result">
                    <div class=""></div>
                </div>`
})
export class PlantingSitePlaceholderComponent {
}
